(function(){
  if(window.__hmSm) return; window.__hmSm=true;
  // Retour arrière : fiche restaurée depuis le cache -> rechargée (bouton jamais grisé)
  window.addEventListener('pageshow',function(e){if(e.persisted&&document.querySelector('[data-sm-product]'))location.reload();});
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  function money(c,fmt){return (fmt||'CHF {{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/,(c/100).toFixed(2));}

  // Carrousels (galerie, avis, cartes)
  function slider(root){
    var tr=$('[data-sm-track]',root); if(!tr||root.__ok) return; root.__ok=1;
    var sl=$$('[data-sm-slide]',tr), dotsBox=$('[data-sm-dots]',root), three=dotsBox&&dotsBox.hasAttribute('data-three'), dots=[];
    if(dotsBox){var n=three?Math.min(3,sl.length):sl.length;for(var k=0;k<n;k++){var d=document.createElement('button');d.type='button';d.className='hm-sm-dot';d.setAttribute('aria-label','Diapositive '+(k+1));dotsBox.appendChild(d);dots.push(d);}}
    function idx(){var best=0,bd=1e9;sl.forEach(function(s,i){var dd=Math.abs(s.offsetLeft-tr.scrollLeft);if(dd<bd){bd=dd;best=i;}});return best;}
    function go(i){i=Math.max(0,Math.min(sl.length-1,i));tr.scrollTo({left:sl[i].offsetLeft,behavior:'smooth'});}
    root.hmGo=go;
    function mark(){var i=idx();dots.forEach(function(d,k){var on=three?((i===0&&k===0)||(i===sl.length-1&&k===dots.length-1)||(i>0&&i<sl.length-1&&k===1)):k===i;d.setAttribute('aria-current',on?'true':'false');});}
    var p=$('[data-sm-prev]',root), nx=$('[data-sm-next]',root);
    if(p) p.addEventListener('click',function(){go(idx()-1)});
    if(nx) nx.addEventListener('click',function(){go(idx()+1)});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(three?(k===0?0:k===dots.length-1?sl.length-1:Math.floor(sl.length/2)):k)})});
    tr.addEventListener('scroll',mark,{passive:true}); mark();
    if(root.hasAttribute('data-auto')&&sl.length>1){setInterval(function(){if(document.hidden)return;var i=idx();go(i>=sl.length-1?0:i+1)},+root.getAttribute('data-auto')*1000||5000);}
  }

  // Fenêtres et photos d'avis
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-sm-open]'); if(o){var m=document.getElementById(o.getAttribute('data-sm-open')); if(m){m.hidden=false;document.body.style.overflow='hidden';} return;}
    var m2=e.target.closest('[data-sm-modal]');
    if(m2&&(e.target===m2||e.target.closest('[data-sm-close]'))){m2.hidden=true;document.body.style.overflow='';return;}
    var z=e.target.closest('[data-sm-zoom]');
    if(z){var lb=document.createElement('div');lb.className='hm-sm hm-sm-lb';lb.innerHTML='<img alt="">';lb.firstChild.src=z.getAttribute('data-sm-zoom');lb.addEventListener('click',function(){lb.remove()});document.body.appendChild(lb);return;}
    var g=e.target.closest('[data-sm-goto]');
    if(g){var t=document.getElementById(g.getAttribute('data-sm-goto'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){$$('[data-sm-modal]').forEach(function(m){if(!m.hidden){m.hidden=true;document.body.style.overflow='';}});$$('.hm-sm-lb').forEach(function(l){l.remove()});}});

  // Avant / après
  function compare(root){
    var inp=$('input',root),a=$('.hm-sm-ba__a',root),bar=$('.hm-sm-ba__bar',root);if(!inp)return;
    function set(){var v=+inp.value;a.style.clipPath='inset(0 0 0 '+v+'%)';bar.style.left=v+'%';}
    inp.addEventListener('input',set);set();
  }

  // Compte à rebours par visiteur (persistant, une seule relance)
  function countdown(root){
    var mins=+root.getAttribute('data-min')||130, key='hmSmCd', now=Date.now(), end=0, rs=0;
    try{end=+localStorage.getItem(key)||0;rs=+localStorage.getItem(key+'R')||0;}catch(e){}
    if(!end){end=now+mins*60000;try{localStorage.setItem(key,end)}catch(e){}}
    var H=$('[data-h]',root),M=$('[data-m]',root),S=$('[data-s]',root);
    function p(n){return (n<10?'0':'')+n}
    function tick(){var left=end-Date.now();if(left<=0){if(!rs){rs=1;end=Date.now()+mins*60000;try{localStorage.setItem(key,end);localStorage.setItem(key+'R','1')}catch(e){}left=end-Date.now();}else left=0;}
      var s=Math.floor(left/1000);H.textContent=p(Math.floor(s/3600));M.textContent=p(Math.floor(s%3600/60));S.textContent=p(s%60);}
    tick();setInterval(tick,1000);
  }

  // Avis : afficher plus
  function reviews(root){
    var items=$$('[data-sm-rv]',root), more=$('[data-sm-more]',root), step=+root.getAttribute('data-step')||5, shown=0;
    function show(){shown+=step;items.forEach(function(it,i){it.hidden=i>=shown});}
    show();
    if(more) more.addEventListener('click',function(){if(shown<items.length){show();}else{more.disabled=true;more.textContent=more.getAttribute('data-loading');setTimeout(function(){more.textContent=more.getAttribute('data-fail');},900);}});
  }

  // Fiche produit
  function product(root){
    var par=root.parentNode, data=JSON.parse(($('[data-sm-variants]',root)||$('[data-sm-variants]',par)).textContent);
    var fmt=root.getAttribute('data-money'), ci=+root.getAttribute('data-ci'), si=+root.getAttribute('data-si');
    var sws=$$('[data-sm-sw]',root), szs=$$('[data-sm-sz]',root), offers=$$('[data-sm-offer]',root), form=$('[data-sm-form]',root), gal=$('[data-sm-gallery]',root);
    var btns=[$('[data-sm-atc]',root)].concat($$('[data-sm-atc2]',document)).filter(Boolean);
    var cur=offers.filter(function(o){return o.getAttribute('aria-pressed')==='true'})[0]||offers[0];
    var c0=sws.length?sws[0].getAttribute('data-sm-sw'):'';
    var st=[0,1,2,3,4].map(function(){return {c:c0,s:'',t:false}});
    function find(c,s){return data.filter(function(v){return v.o[ci]===c&&v.o[si]===s})[0];}
    function n(o){return +o.getAttribute('data-units')}
    function priceOf(i){var v=find(st[i].c,st[i].s)||data.filter(function(x){return x.o[ci]===st[i].c})[0]||data[0];return v;}
    var sending=false;
    function render(){
      sws.forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-sm-sw')===st[0].c?'true':'false')});
      szs.forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-sm-sz')===st[0].s?'true':'false')});
      var cl=$('[data-sm-clabel]',root);if(cl)cl.textContent=st[0].c;
      offers.forEach(function(o){
        o.setAttribute('aria-pressed',o===cur?'true':'false');
        var k=n(o),tot=0,cmp=0;
        for(var i=0;i<k;i++){var v=priceOf(i);tot+=v.p;cmp+=Math.max(v.c,v.p);}
        var pct=parseFloat(o.getAttribute('data-pct'))||0;tot=Math.round(tot*(100-pct)/100);
        var each=k>1?Math.floor(tot/k):tot, eachC=Math.round(cmp/k);
        var sv=$('[data-sm-save]',o),sub=$('[data-sm-subtxt]',o),op=$('[data-sm-op]',o),oc=$('[data-sm-oc]',o),oe=$('[data-sm-oe]',o);
        var per=cmp>tot?Math.round((cmp-tot)*100/cmp):0;
        if(sv)sv.textContent=o.getAttribute('data-save-label').replace('[pourcentage]',per+' %');
        if(sub)sub.textContent=o.getAttribute('data-sub').replace('[montant]',money(cmp-tot,fmt));
        if(op)op.textContent=money(each,fmt);
        if(oe)oe.hidden=k<2;
        if(oc)oc.textContent=money(eachC,fmt);
        $$('[data-sm-unit]',o).forEach(function(u){
          var i=+u.getAttribute('data-sm-unit'), sc=$('[data-sm-sel=c]',u), ss=$('[data-sm-sel=s]',u);
          if(sc&&sc.value!==st[i].c)sc.value=st[i].c;
          if(ss&&ss.value!==st[i].s)ss.value=st[i].s;
        });
      });
      var k2=n(cur),ok=true,lack=false;
      for(var i=0;i<k2;i++){if(!st[i].s){ok=false;lack=true;break;}var v=find(st[i].c,st[i].s);if(!v||!v.a)ok=false;}
      btns.forEach(function(b){if(!sending)b.disabled=false;b.classList.toggle('is-off',!ok);b.setAttribute('aria-disabled',ok?'false':'true');b.textContent=lack?b.getAttribute('data-label-off'):b.getAttribute('data-label-on');});
      var sl=$('[data-sm-slabel]',root);if(sl)sl.textContent=st[0].s?('· '+st[0].s):'';
    }
    function jump(){
      var v=find(st[0].c,st[0].s)||data.filter(function(x){return x.o[ci]===st[0].c})[0]; if(!v||!v.m||!gal||!gal.hmGo) return;
      $$('[data-sm-slide]',gal).forEach(function(s,i){if(+s.getAttribute('data-media')===v.m)gal.hmGo(i)});
    }
    function follow(){for(var i=1;i<5;i++){if(!st[i].t){st[i].c=st[0].c;st[i].s=st[0].s;}}}
    sws.forEach(function(b){b.addEventListener('click',function(){st[0].c=b.getAttribute('data-sm-sw');follow();jump();render();})});
    szs.forEach(function(b){b.addEventListener('click',function(){st[0].s=b.getAttribute('data-sm-sz');follow();render();})});
    offers.forEach(function(o){
      $('[data-sm-pick]',o).addEventListener('click',function(){cur=o;render();});
      $$('[data-sm-unit]',o).forEach(function(u){
        var i=+u.getAttribute('data-sm-unit');
        $$('select',u).forEach(function(sel){sel.addEventListener('change',function(){
          st[i].t=true;if(sel.getAttribute('data-sm-sel')==='c')st[i].c=sel.value;else st[i].s=sel.value;render();
        });});
      });
    });
    function submit(e){
      e.preventDefault(); var msg=$('[data-sm-msg]',form); msg.textContent='';
      var agg={}, ok=true;
      for(var j=0;j<n(cur);j++){if(!st[j].s){
        msg.textContent=form.getAttribute('data-pick');
        var tg=j===0?$('.hm-sm-sz',root):$$('[data-sm-unit]',cur)[j-1];
        if(tg){tg.classList.add('hm-sm-pulse');setTimeout(function(){tg.classList.remove('hm-sm-pulse')},2200);try{tg.scrollIntoView({behavior:'smooth',block:'center'})}catch(e){}}
        return;}}
      for(var i=0;i<n(cur);i++){var v=find(st[i].c,st[i].s); if(!v||!v.a){ok=false;break;} agg[v.id]=(agg[v.id]||0)+1;}
      if(!ok){msg.textContent=form.getAttribute('data-unavailable');return;}
      var items=Object.keys(agg).map(function(id){return {id:+id,quantity:agg[id]}});
      var gv=+root.getAttribute('data-gift-variant');if(cur.getAttribute('data-gift')==='1'&&gv)items.push({id:gv,quantity:1});
      sending=true;btns.forEach(function(b){b.disabled=true});
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';})
        .catch(function(){sending=false;render();msg.textContent=form.getAttribute('data-error');});
    }
    form.addEventListener('submit',submit);
    $$('[data-sm-atc2]',document).forEach(function(b){b.addEventListener('click',function(){form.requestSubmit?form.requestSubmit():submit({preventDefault:function(){}});})});
    // barre d'achat fixe
    var bar=$('[data-sm-sticky]',document), main=btns[0];
    if(bar&&main&&'IntersectionObserver' in window){new IntersectionObserver(function(es){var e=es[0];bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);}).observe(main);}
    render();
  }
  function init(){
    $$('[data-sm-slider]').forEach(function(el){try{slider(el)}catch(err){console.error('hm-sm',err)}});
    $$('[data-sm-product]').forEach(function(el){try{product(el)}catch(err){console.error('hm-sm',err)}});
    $$('[data-sm-compare]').forEach(function(el){try{compare(el)}catch(err){console.error('hm-sm',err)}});
    $$('[data-sm-cd]').forEach(function(el){try{countdown(el)}catch(err){console.error('hm-sm',err)}});
    $$('[data-sm-reviews]').forEach(function(el){try{reviews(el)}catch(err){console.error('hm-sm',err)}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){$$('[data-sm-slider]').forEach(slider);$$('[data-sm-compare]').forEach(compare);});
})();
